import script from "./CommitteeDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./CommitteeDetails.vue?vue&type=script&setup=true&lang=js"

import "./CommitteeDetails.vue?vue&type=style&index=0&id=48b3b7c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b3b7c4"]])

export default __exports__